/**
 * Adds behaviors needed on all forms (e.g. reset default values after successful submit).
 * We're in discussion on whether this is useful for other teams as well and should be moved into zion-form.
 */
import { useZionForm } from '@fs/zion-form'
import useFormResetOnSubmitSuccess from './useFormResetOnSubmitSuccess'

export default function useZionFormWrapper(props) {
  const defaultValues = props.defaultValues
  const methods = useZionForm(props)
  useFormResetOnSubmitSuccess(methods, defaultValues)
  return methods
}
